export default __webpack_public_path__ + "static/media/minus-orange-diamond-icon.19a67090.svg";